const features = [
  {
    icon: "ri-time-line",
    title: "Real-Time Tracking",
    description: "Monitor every purchase in real time with the mulebuy spreadsheet system. Never lose track of an order again and stay updated on shipping status, delivery estimates, and payment confirmations all in one place.",
  },
  {
    icon: "ri-scales-3-line",
    title: "Cost Comparison",
    description: "Compare prices across different platforms effortlessly using your mulebuy spreadsheet. The built-in formulas help you identify the best deals and optimize your total spending on every agent shopping trip.",
  },
  {
    icon: "ri-archive-line",
    title: "Inventory Management",
    description: "Organize all your purchased items with structured inventory sheets. The mulebuy spreadsheet lets you categorize by type, track quantities, and maintain a clear overview of everything you have ordered.",
  },
];

export default function FeatureGrid() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-medium text-foreground-400 uppercase tracking-wider mb-3">
            Why Mulebuy Spreadsheet Matters
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-[1.05] tracking-tight">
            Organize Orders<span className="block text-accent-500">Save Money</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-100 rounded-xl p-6 md:p-8 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center text-foreground-700 mb-5">
                <i className={`${feat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}